import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APP_CONFIG_TOKEN } from 'projects/bo/src/app/core/services/abstracts/app-config.abstract';
import { LoadingService } from 'projects/bo/src/app/core/services/helpers/loading.service';
import { Observable, catchError, map, throwError } from 'rxjs';

import { ApiUIActionCode } from '../../../shared/constants/api-ui-action-code';
import { RefreshTokenService } from './background-services/refresh-token.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  protected appconfig = inject(APP_CONFIG_TOKEN);
  protected refreshTokenService = inject(RefreshTokenService);
  protected loadingService = inject(LoadingService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.apiWithoutAuthorization(req)) {
      return next.handle(req);
    } else {
      return next.handle(req).pipe(
        map(this.handleResponse),
        catchError((error: HttpErrorResponse) => {
          return this.handleError(error, req, next);
        })
      );
    }
  }

  protected handleResponse = (res: any) => {
    if (res.headers && (res.body.code || res.body.Code)) {
      const code = res.body.code ?? res.body.Code;
      let codePrefix = Number(code.toString().substring(0, 2));
      if (codePrefix == ApiUIActionCode.RenewApiToken) {
        throw new HttpErrorResponse({
          error: 'Token expired',
          headers: res.headers,
          status: 401,
          statusText: 'Unauthorized',
          url: res.url
        });
      }
    }
    return res;
  };

  protected handleError(error: HttpErrorResponse, req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (error.status == 401) {
      return this.renewToken(req, next);
    } else {
      return throwError(error);
    }
  }

  protected renewToken(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.refreshTokenService.refreshToken(req, next);
  }

  protected apiWithoutAuthorization(req: HttpRequest<any>): boolean {
    return (
      !req.headers.has('Authorization') ||
      req.headers.get('Authorization') == null ||
      req.headers.get('Authorization') == '' ||
      req.url.includes('UserLogout')
    );
  }
}
